const ProcessedByText = ({ provider }) => {
  const stripeLink = 'https://stripe.com/privacy';
  const stripeText = 'Stripe';

  const providerLink = () => {
    switch (provider) {
      case 'pay_pal':
        return 'https://www.paypal.com/us/privacy-center';
      case 'plaid':
        return 'https://plaid.com/legal/#end-user-privacy-policy';
      default:
        return stripeLink;
    }
  };
  const providerText = () => {
    switch (provider) {
      case 'pay_pal':
        return 'PayPal';
      case 'plaid':
        return 'Plaid';
      default:
        return stripeText;
    }
  };

  const secondaryStripeText = () => {
    if (provider !== 'plaid') {
      return null;
    }

    return (
      <>
        {' & '}
        <a href={stripeLink}>{stripeText}</a>
      </>
    );
  };

  return (
    <p className='calm-disclaimer-text'>
      Payment is processed by <a href={providerLink()}>{providerText()}</a>
      {secondaryStripeText()}.
    </p>
  );
};

export default ProcessedByText;
